import { render, staticRenderFns } from "./NewProductSize.vue?vue&type=template&id=19df9cee&scoped=true"
import script from "./NewProductSize.vue?vue&type=script&lang=js"
export * from "./NewProductSize.vue?vue&type=script&lang=js"
import style0 from "./NewProductSize.vue?vue&type=style&index=0&id=19df9cee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df9cee",
  null
  
)

export default component.exports